import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './pageControl.html';
import { TopicsSliderTopic } from './topic';

export interface TopicsSliderPageControlVMConfig {
    pages: SubscribableOrNullableValue<Array<any>>
}

@injectable()
export default class TopicsSliderPageControlVM {
    labels = labels;

    hasToDo: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: TopicsSliderPageControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const pages = ko.flattenComputed(config.pages, []);
        const items = pages.pluck('items').flatten();
        const topics = items.pluck(item => <TopicsSliderTopic>item.data).pluck(item => item.topic);
        const todoCount = topics.reduce((count, topic) => count + (topic.isAnswered() ? 0 : 1), () => 0);
        this.hasToDo = todoCount.is(v => v > 0);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'task__topics-slider__page-control': true,
                'task__topics-slider__page-control--with-todo': this.hasToDo,
                'wcc-slider__control__body': true,
                'qzy-primary-color': true
            }
        });
    }
}